/** Screens of the sign-in flow: never a destination after signing in (it would loop). */
export const AUTH_PATHS = ['/login', '/register', '/forgot-password', '/reset-password'] as const;

export function isAuthPath(pathname: string): boolean {
  return AUTH_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

/** Never a destination either: the screen of a pending password change (it would loop). */
const PASSWORD_CHANGE_PATH = '/change-password';

function isControlCharacter(character: string): boolean {
  const code = character.codePointAt(0) ?? 0;
  return code < 0x20 || code === 0x7f;
}

/**
 * Where to go after signing in, from `?next=`. Only same-origin relative paths: anything
 * else (`https://…`, `//evil.com`, `/\evil.com` — which browsers read as `//evil.com` —,
 * control characters, the auth screens themselves, `/change-password`) falls back to
 * `fallback`.
 */
export function safeNextPath(next: unknown, fallback = '/'): string {
  if (typeof next !== 'string' || !next.startsWith('/') || next.startsWith('//')) return fallback;
  if (next.includes('\\') || [...next].some(isControlCharacter)) return fallback;
  const pathname = next.split(/[?#]/, 1)[0] ?? '';
  if (isAuthPath(pathname) || pathname === PASSWORD_CHANGE_PATH) return fallback;
  return next;
}
